import styled from 'styled-components';
import { h3Styles } from '~typography';
var Subtitle = styled.span.withConfig({
  displayName: "Subtitle",
  componentId: "sc-1m0cmqi-0"
})(["", " clear:both;float:left;margin:0;"], h3Styles);
export default Subtitle;